<section class="funnel">
  <div class="funnel__rows">
    <ifbp-pipeline-funnel-bar
      class="funnel__row"
      *ngFor="let bar of bars; trackBy: trackByStage"
      [vm]="bar"
    ></ifbp-pipeline-funnel-bar>
  </div>
  <p class="funnel__legend">
    <span class="funnel__legend-swatch" aria-hidden="true"></span>
    <span class="funnel__legend-label">{{ legendLabel }}</span>
  </p>
</section>
